import { makeStyles } from "@material-ui/styles"

const styles = makeStyles(theme => ({
  paper: {
    width: "100%",
    maxWidth: 500
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.primary.main,
    overflow: "unset"
  },
  headerTitle: {
    color: theme.palette.warning.light,
    textTransform: "none",
    "@supports (padding-top: constant(safe-area-inset-top))": {
      "--safe-area-inset-top": "constant(safe-area-inset-top)",
      paddingTop: "var(--safe-area-inset-top)"
    },
    "@supports (padding-top: env(safe-area-inset-top))": {
      "--safe-area-inset-top": "env(safe-area-inset-top)",
      paddingTop: "var(--safe-area-inset-top)"
    }
  },
  closeButton: {
    color: "#fff",
    fontWeight: 700
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationEmail/ManageTagsDialog/styles.js